import { createStyles, Theme, withStyles } from '@material-ui/core';
import FormLabel from '@material-ui/core/FormLabel';
import IconButton from '@material-ui/core/IconButton';
import SvgIcon from '@material-ui/core/SvgIcon';
import * as React from 'react';
import { DateRangeNavigatorFunctions } from '../../store/types';

export interface FixedDateRangeNavigatorProps {
  startDate: Date;
  endDate: Date;
}

export interface FixedDateRangeNavigatorActions {
  setRange: (startDate: Date, endDate: Date) => void;
}

interface StylesProps {
  classes: {
    chevron: string;
    label: string;
  };
}

type AllProps = FixedDateRangeNavigatorProps &
  DateRangeNavigatorFunctions &
  FixedDateRangeNavigatorActions &
  StylesProps;

const styles = (theme: Theme) =>
  createStyles({
    chevron: {
      padding: '4px'
    },
    label: {
      marginLeft: '10px',
      marginBottom: '0px',
      fontWeight: 'inherit'
    }
  });

class FixedDateRangeNavigator extends React.Component<AllProps> {
  constructor(props: AllProps) {
    super(props);
  }
  public render() {
    return (
      <div className="dateRangeNavigator">
        <IconButton onClick={this.previous} className={this.props.classes.chevron}>
          <SvgIcon>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
              <path d="M0 0h24v24H0z" fill="none" />
            </svg>
          </SvgIcon>
        </IconButton>
        <IconButton onClick={this.next} className={this.props.classes.chevron}>
          <SvgIcon>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
              <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
              <path d="M0 0h24v24H0z" fill="none" />
            </svg>
          </SvgIcon>
        </IconButton>
        {/* <span>{this.props.info(this.props.startDate, this.props.endDate)}</span> */}
        <FormLabel className={this.props.classes.label}>
          {this.props.info(this.props.startDate, this.props.endDate)}
        </FormLabel>
      </div>
    );
  }

  private previous = () => {
    const newRange = this.props.previous(this.props.startDate, this.props.endDate);
    this.props.setRange(newRange.startDate, newRange.endDate);
  };

  private next = () => {
    const newRange = this.props.next(this.props.startDate, this.props.endDate);
    this.props.setRange(newRange.startDate, newRange.endDate);
  };
}

export default withStyles(styles)(FixedDateRangeNavigator);



// WEBPACK FOOTER //
// ./src/components/navbar/FixedDateRangeNavigator.tsx